<template>
  <div class="yzm-foldbutton">
    <img :src="icon" alt="" />
  </div>
</template>
<script setup>
import { defineProps, computed, onMounted, defineEmits } from 'vue'
import { defaultProps } from './defaultProps'
import Icon1 from '@/assets/images/card/icon1.png'
import Icon2 from '@/assets/images/card/icon1.png'
import Icon3 from '@/assets/images/card/icon1.png'
import Icon4 from '@/assets/images/card/icon1.png'
const props = defineProps({
  ...defaultProps
})
const icon = computed(() => {
  let obj = {
    0: Icon1,
    1: Icon2,
    2: Icon3,
    3: Icon1
  }
  return obj[props.item.setting.textValue]
})
const emit = defineEmits(['childMounted'])
onMounted(() => {
  emit('childMounted')
})
</script>
<style lang="less" scoped>
.yzm-foldbutton {
}
</style>
